import type { DocumentExtractionJob } from "./documentExtractionJobs";

export const DOC_EXTRACTION_REVIEW_EVENT = "doc-extraction-review";
export const DOC_EXTRACTION_ETL_SYNC_EVENT = "doc-extraction-etl-sync";
export const DOC_EXTRACTION_DOCUMENT_DELETED_EVENT = "doc-extraction-document-deleted";

export type ExtractionEtlSyncDetail = {
  documentId: string;
  etl: {
    status?: string | null;
    progress?: number | null;
    stage?: string | null;
    error?: string | null;
    processed_at?: string | null;
  };
};

export type DocumentDeletedDetail = {
  documentId: string;
};

export function dispatchExtractionEtlSync(detail: ExtractionEtlSyncDetail): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<ExtractionEtlSyncDetail>(DOC_EXTRACTION_ETL_SYNC_EVENT, { detail })
  );
}

export function onExtractionEtlSync(
  handler: (detail: ExtractionEtlSyncDetail) => void
): () => void {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<ExtractionEtlSyncDetail>).detail;
    if (detail?.documentId) handler(detail);
  };
  window.addEventListener(DOC_EXTRACTION_ETL_SYNC_EVENT, listener);
  return () => window.removeEventListener(DOC_EXTRACTION_ETL_SYNC_EVENT, listener);
}

export function dispatchDocumentDeleted(documentId: string): void {
  if (typeof window === "undefined" || !documentId) return;
  window.dispatchEvent(
    new CustomEvent<DocumentDeletedDetail>(DOC_EXTRACTION_DOCUMENT_DELETED_EVENT, {
      detail: { documentId },
    })
  );
}

export function onDocumentDeleted(
  handler: (documentId: string) => void
): () => void {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => {
    const detail = (e as CustomEvent<DocumentDeletedDetail>).detail;
    if (detail?.documentId) handler(detail.documentId);
  };
  window.addEventListener(DOC_EXTRACTION_DOCUMENT_DELETED_EVENT, listener);
  return () => window.removeEventListener(DOC_EXTRACTION_DOCUMENT_DELETED_EVENT, listener);
}

export function dispatchExtractionReviewReady(job: DocumentExtractionJob): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent<DocumentExtractionJob>(DOC_EXTRACTION_REVIEW_EVENT, { detail: job })
  );
}

export function onExtractionReviewReady(
  handler: (job: DocumentExtractionJob) => void
): () => void {
  if (typeof window === "undefined") return () => {};
  const listener = (e: Event) => {
    const job = (e as CustomEvent<DocumentExtractionJob>).detail;
    if (job?.documentId) handler(job);
  };
  window.addEventListener(DOC_EXTRACTION_REVIEW_EVENT, listener);
  return () => window.removeEventListener(DOC_EXTRACTION_REVIEW_EVENT, listener);
}
